import React, { Component } from 'react';
import SimpleDate from '../../Common/SimpleDate';
import { HTMLTrans } from '../../Common/Translations';
import { isMobile } from 'react-device-detect';

export default class ReminderForm extends Component {
  constructor(props) {
    super(props);
    this.initState();
    this.bind()
  }

  bind() {
    this.submitReminder = this.submitReminder.bind(this);
  }

  isValid() {
    if (!this.state.selectedUserReminderType) {
      return false;
    }
    if (this.state.selectedUserReminderType.code === 'birthday' && !this.state.selectedUserReminderTypeOption) {
      return false;
    }
    return !!this.state.reminderDate && !!this.state.title;
  }

  preventDefault(e) {
    e.preventDefault();
    return false;
  }

  submitReminder(e) {
    e.preventDefault();
    this.props.submitNewData(this.getParamsFromState());
    return false;
  }

  changeSelectedType(clickedType) {
    this.setState({
      selectedUserReminderType: clickedType
    });
  }

  closeButton() {
    return <button
      type="button"
      className="close"
      data-dismiss={this.props.modalIdToDismiss}
      aria-label="Close"
      onClick={this.props.closeModal}
    >
      <span aria-hidden="true">&times;</span>
    </button>
  }

  typesButtons(selectedType) {
    return <div className="form-group d-flex modal-reminder-input-row">
      {!isMobile && <span className="m-3">
          <i className="fa fa-star-o fa-lg"></i>
        </span>
      }
      {this.props.reminderTypes.map(userReminderType => (
        <button
          key={'reminder-type-' + userReminderType.id}
          type='button'
          onClick={() => this.changeSelectedType(userReminderType)}
          className={`text-capitalize 
            ${userReminderType.id === (selectedType ? selectedType.id : 0) ? 'btn btn-primary' : 'modal-reminder-unselected-button'}`
          }>
          {userReminderType.name}
        </button>
      ))}
    </div>
  }

  optionsButtons(userReminderTypeOptions) {
    return <div className="form-group d-flex modal-reminder-input-row">
      {!isMobile && <span className="m-3">
          <i className="fa fa-user-circle-o fa-lg"></i>
        </span>
      }
      {userReminderTypeOptions.map(typeOption => (
        <button
          key={'reminder-type-option' + typeOption.id}
          type='button'
          onClick={() => this.setState({selectedUserReminderTypeOption: typeOption.id})}
          className={`text-capitalize
            ${typeOption.id === this.state.selectedUserReminderTypeOption ? 'btn btn-primary' : 'modal-reminder-unselected-button'}
          `}>
          {typeOption.name}
        </button>
      ))}
    </div>
  }

  titleField() {
    return <div className="form-group d-flex modal-reminder-input-row">
      {!isMobile && <span className="m-3">
          <i className="fa fa-text-width fa-lg"></i>
        </span>
      }
      <div className='col-10 pl-0 pt-1'>
        <input
          type="text"
          placeholder={this.props.t('account.dasboard_reminder_modal_add_title_placeholder', 'Add Title')}
          className="form-control"
          value={this.state.title}
          onChange={(e) => this.setState({title: e.target.value})}
          required
          maxLength="30"
        />
      </div>
    </div>
  }

  dateField() {
    return <div className="form-group d-flex modal-reminder-input-row">
      {!isMobile && <span className="m-3">
          <i className="fa fa-clock-o fa-lg"></i>
        </span>
      }
      <SimpleDate
        value={this.state.reminderDate}
        onChange={(e) => this.setState({reminderDate: e.target.value})}
        required
        formClass='pt-1'
      />
    </div>
  }

  isRecurringField() {
    return <div className="form-group d-flex modal-reminder-input-row">
      <input
        checked={!this.state.isRecurring}
        type='checkbox'
        onChange={(e) => this.setState({isRecurring: !e.target.checked})}
        className='form-control reminder-checkbox-recurring'
      />
      <p>
        <b><HTMLTrans id='account.dasboard_reminder_one_off'>One Off</HTMLTrans></b>
        <br/>
        <HTMLTrans id='account.dasboard_reminder_one_off_description'>This event will not be repeated yearly.</HTMLTrans>
      </p>
    </div>
  }

  isRecurringRow() {
    return isMobile ? this.isRecurringField() :
      <div className="row">
        <div className="col-1"></div>
        <div className="col-11">{this.isRecurringField()}</div>
      </div>
  }

  render() {
    const selectedType = this.state.selectedUserReminderType;
    return <form className="card border-0" onSubmit={this.preventDefault}>
      {this.modalHeader()}
      <div className="modal-body pt-0">
          {this.typesButtons(selectedType)}
          {selectedType && selectedType.userReminderTypeOptions.length > 0 && 
            this.optionsButtons(selectedType.userReminderTypeOptions)
          }
        {this.titleField()}
        {this.dateField()}
        {selectedType && selectedType.code === 'others' &&
          this.isRecurringRow()
        }
        {this.actionButtons()}
      </div>
    </form>
  }
}



// WEBPACK FOOTER //
// ./src/Account/RemindMe/ReminderForm.js